//mui
import {Box} from '@mui/material';
//components
import AddTicketActions from '../AddTicketActions';
import TablePurchaser from './TablePurchaser';
import TicketsTiers from './TicketsTiers';

const AttendeesInfo = ({isFromPage}: {isFromPage?: boolean}) => {

	return (
		<Box>
			<TablePurchaser />
			<TicketsTiers />
			<AddTicketActions isFromPage={isFromPage} />
		</Box>
	);
};

export default AttendeesInfo;
